/**
 * Klivlo LED Hand Sign - page behaviour (prefix khs-).
 *
 * Offer shape: the 3 bundles are REAL variants of one product (1/2/3 Hand
 * Signs), each with its own price and compare-at, so cart and checkout charge
 * exactly what each card shows. No client-side discount maths.
 *
 * Money is formatted with Intl.NumberFormat from the cart/market currency, so
 * the same script shows $29.95 on the US market and EUR on the French one
 * (never a hard-coded currency symbol).
 *
 * Loaded as type="module" so it can import the theme's own `@shopify/events`
 * and keep the native header cart icon in sync (04-traps.md D8).
 */
import { CartLinesUpdateEvent } from '@shopify/events';

var dataEl = document.getElementById('khs-data');
var DATA = dataEl ? JSON.parse(dataEl.textContent) : null;

function $(sel, root) { return (root || document).querySelector(sel); }
function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

var nf;
function fmt(cents) {
  if (!nf) {
    try {
      nf = new Intl.NumberFormat(DATA.locale || document.documentElement.lang || 'en-US', { style: 'currency', currency: DATA.currency });
    } catch (e) {
      nf = { format: function (n) { return DATA.currency + ' ' + n.toFixed(2); } };
    }
  }
  return nf.format((Number(cents) || 0) / 100);
}
function pad(n) { return String(n).padStart(2, '0'); }

/* ---------------- Gallery ---------------- */
$$('[data-khs-thumb]').forEach(function (thumb) {
  thumb.addEventListener('click', function () { showImage(Number(thumb.getAttribute('data-khs-thumb'))); });
});
function showImage(i) {
  $$('[data-khs-thumb]').forEach(function (t) {
    var on = Number(t.getAttribute('data-khs-thumb')) === i;
    t.classList.toggle('is-active', on);
    t.setAttribute('aria-current', on ? 'true' : 'false');
  });
  $$('.khs-stage .khs-slide').forEach(function (img, n) { img.classList.toggle('is-active', n === i); });
}

/* ---------------- Accordions (one open per group) ---------------- */
$$('[data-khs-acc]').forEach(function (group) {
  var items = $$('[data-khs-acc-item]', group);
  items.forEach(function (item) {
    var btn = $('[data-khs-acc-btn]', item);
    var panel = $('[data-khs-acc-panel]', item);
    var icon = $('[data-khs-acc-icon]', item);
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      items.forEach(function (other) {
        var b = $('[data-khs-acc-btn]', other);
        var open2 = other === item && !open;
        b.setAttribute('aria-expanded', open2 ? 'true' : 'false');
        $('[data-khs-acc-panel]', other).hidden = !open2;
        $('[data-khs-acc-icon]', other).textContent = open2 ? '−' : '+';
      });
    });
  });
});

/* ---------------- Sale countdown (announcement bar) ----------------
   Default per the handoff: counts down to local midnight. If the merchant
   sets a real end date it counts to that instead and hides when it passes. */
(function () {
  var bar = $('[data-khs-countdown]');
  if (!bar) return;
  var endIso = bar.getAttribute('data-end');
  var fixed = endIso ? new Date(endIso).getTime() : NaN;
  var hasFixed = !isNaN(fixed);
  var chips = { h: $('[data-khs-cd="h"]', bar), m: $('[data-khs-cd="m"]', bar), s: $('[data-khs-cd="s"]', bar) };
  function tick() {
    var now = new Date();
    var end = hasFixed ? fixed : new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999).getTime();
    var left = end - now.getTime();
    if (left <= 0) { bar.hidden = true; return; }
    chips.h.textContent = pad(Math.floor(left / 3.6e6)) + 'h';
    chips.m.textContent = pad(Math.floor(left / 6e4) % 60) + 'm';
    chips.s.textContent = pad(Math.floor(left / 1e3) % 60) + 's';
  }
  tick();
  setInterval(tick, 1000);
})();

if (DATA) initBuy();

function initBuy() {
  var tiers = DATA.tiers;
  var byVariant = {};
  tiers.forEach(function (t) { byVariant[t.variantId] = t; });
  var state = { tier: DATA.defaultTier, added: false, flash: null };

  /* ---------- Bundle radio group ---------- */
  var packs = $$('[data-khs-pack]');
  packs.forEach(function (b, i) {
    b.addEventListener('click', function () { select(i); });
    b.addEventListener('keydown', function (e) {
      var k = e.key, next = -1;
      if (k === 'ArrowDown' || k === 'ArrowRight') next = (i + 1) % packs.length;
      else if (k === 'ArrowUp' || k === 'ArrowLeft') next = (i - 1 + packs.length) % packs.length;
      if (next > -1) { e.preventDefault(); select(next); packs[next].focus(); }
    });
  });
  function select(i) { state.tier = i; render(); }

  function render() {
    var t = tiers[state.tier];
    packs.forEach(function (b, i) {
      var on = i === state.tier;
      b.classList.toggle('is-selected', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
      b.tabIndex = on ? 0 : -1;
    });
    var label = state.added ? DATA.text.added : DATA.text.cta + ' — ' + fmt(t.price);
    $$('[data-khs-cta]').forEach(function (el) { el.textContent = label; });
    $$('[data-khs-sticky-name]').forEach(function (el) { el.textContent = t.name; });
    $$('[data-khs-sticky-price]').forEach(function (el) { el.textContent = fmt(t.price); });
  }
  render();

  /* ---------- Gift button: pick the 2-pack and scroll to top ---------- */
  $$('[data-khs-pick-gift]').forEach(function (b) {
    b.addEventListener('click', function () {
      select(Math.min(1, tiers.length - 1));
      showImage(0);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  });

  /* ---------- Add to cart ---------- */
  function cartEvent(action, context, lines, promise) {
    document.dispatchEvent(new CartLinesUpdateEvent({ action: action, context: context, lines: lines, promise: promise }));
  }
  function fetchCart() {
    return fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function post(path, body) {
    return fetch(window.Shopify.routes.root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (j) {
        if (!res.ok) throw new Error(j.description || j.message || 'Request failed');
        return j;
      });
    });
  }

  function addToCart(variantId, opts) {
    opts = opts || {};
    var buttons = $$('[data-khs-add]');
    buttons.forEach(function (b) { b.disabled = true; });
    var deferred = CartLinesUpdateEvent.createPromise();
    cartEvent('add', 'product', [{ merchandiseId: variantId, quantity: 1 }], deferred.promise);
    return post('cart/add.js', { items: [{ id: variantId, quantity: 1 }] })
      .then(fetchCart)
      .then(function (cart) {
        deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { didError: false, items: cart.items, source: 'khs-buy-box' } });
        startReserve();
        state.added = true;
        render();
        clearTimeout(state.flash);
        state.flash = setTimeout(function () { state.added = false; render(); }, 2200);
        drawCart(cart);
        openDrawer(true);
      })
      .catch(function (err) {
        console.error('[khs] add to cart failed', err);
        deferred.reject(err);
        alert(err.message || 'Something went wrong. Please try again.');
      })
      .finally(function () { buttons.forEach(function (b) { b.disabled = false; }); });
  }
  $$('[data-khs-add]').forEach(function (b) {
    b.addEventListener('click', function () { addToCart(tiers[state.tier].variantId); });
  });

  /* ---------- Sticky bar ---------- */
  var sticky = $('[data-khs-sticky]');
  if (sticky) {
    var drawerEl = $('[data-khs-drawer]');
    var onScroll = function () {
      var show = window.scrollY > 900 && !(drawerEl && !drawerEl.hidden);
      sticky.classList.toggle('is-visible', show);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Cart drawer ---------- */
  var drawer = $('[data-khs-drawer]');
  if (!drawer) return;
  var panel = $('.khs-panel', drawer);
  var linesEl = $('[data-khs-lines]', drawer);
  var lineTpl = $('[data-khs-line-tpl]', drawer);
  var upsell = $('[data-khs-upsell]', drawer);
  var lastFocused = null;

  function openDrawer(open) {
    if (open) {
      lastFocused = document.activeElement;
      drawer.hidden = false;
      requestAnimationFrame(function () { drawer.classList.add('is-open'); });
      document.documentElement.classList.add('khs-lock');
      startReserve();
      tick();
      $('[data-khs-close]', drawer).focus({ preventScroll: true });
    } else {
      drawer.classList.remove('is-open');
      document.documentElement.classList.remove('khs-lock');
      setTimeout(function () { if (!drawer.classList.contains('is-open')) drawer.hidden = true; }, 350);
      if (lastFocused && lastFocused.focus) lastFocused.focus({ preventScroll: true });
    }
  }

  function drawCart(cart) {
    var has = cart.item_count > 0;
    $$('[data-khs-count]', drawer).forEach(function (el) { el.textContent = cart.item_count; });
    $$('[data-khs-badge]').forEach(function (el) { el.textContent = cart.item_count; el.hidden = !has; });
    $('[data-khs-empty]', drawer).hidden = has;
    $('[data-khs-foot]', drawer).hidden = !has;

    var savings = 0;
    linesEl.innerHTML = '';
    cart.items.forEach(function (item) {
      var t = byVariant[item.variant_id];
      if (t && t.compare > t.price) savings += (t.compare - t.price) * item.quantity;
      var node = lineTpl.content.firstElementChild.cloneNode(true);
      var img = $('img', node);
      if (item.image) { img.src = item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=168'; img.alt = item.product_title; }
      else { img.remove(); }
      $('[data-f="name"]', node).textContent = item.product_title;
      $('[data-f="meta"]', node).textContent = t ? t.name + ' · ' + t.sub : (item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '');
      $('[data-f="qty"]', node).textContent = item.quantity;
      $('[data-f="total"]', node).textContent = fmt(item.final_line_price);
      var was = $('[data-f="was"]', node);
      if (t && t.compare > item.final_price) was.textContent = fmt(t.compare * item.quantity); else was.remove();
      $$('[data-khs-change]', node).forEach(function (b) {
        b.addEventListener('click', function () {
          var d = b.getAttribute('data-khs-change');
          var q = d === 'remove' ? 0 : Math.max(0, item.quantity + Number(d));
          if (q !== item.quantity) changeLine(item.key, q);
        });
      });
      linesEl.appendChild(node);
    });
    $('[data-khs-savings]', drawer).textContent = fmt(savings);
    $$('[data-khs-subtotal]', drawer).forEach(function (el) { el.textContent = fmt(cart.total_price); });

    // Upsell: only when the cart is exactly one 1-pack
    var showUp = cart.items.length === 1 && cart.items[0].variant_id === tiers[0].variantId && cart.items[0].quantity === 1 && tiers.length > 1;
    upsell.hidden = !showUp;
    if (showUp) {
      $('[data-khs-up-delta]', upsell).textContent = fmt(tiers[1].price - tiers[0].price);
      upsell.setAttribute('data-key', cart.items[0].key);
    }
  }

  function changeLine(key, quantity) {
    drawer.classList.add('is-busy');
    var deferred = CartLinesUpdateEvent.createPromise();
    cartEvent(quantity === 0 ? 'remove' : 'update', 'cart', [{ id: key, quantity: quantity }], deferred.promise);
    post('cart/change.js', { id: key, quantity: quantity })
      .then(function (cart) {
        deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { didError: false } });
        drawCart(cart);
        if (cart.item_count === 0) clearReserve();
      })
      .catch(function (err) { deferred.reject(err); console.error('[khs] cart change failed', err); })
      .finally(function () { drawer.classList.remove('is-busy'); });
  }

  // Swap the 1-pack line for the 2-pack (add first so the cart is never empty)
  $('[data-khs-upgrade]', drawer).addEventListener('click', function () {
    var key = upsell.getAttribute('data-key');
    var deferred = CartLinesUpdateEvent.createPromise();
    cartEvent('add', 'cart', [{ merchandiseId: tiers[1].variantId, quantity: 1 }], deferred.promise);
    post('cart/add.js', { items: [{ id: tiers[1].variantId, quantity: 1 }] })
      .then(function () { return post('cart/change.js', { id: key, quantity: 0 }); })
      .then(function (cart) {
        deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { didError: false } });
        drawCart(cart);
      })
      .catch(function (err) { deferred.reject(err); console.error('[khs] upgrade failed', err); });
  });

  $$('[data-khs-close]', drawer).forEach(function (b) { b.addEventListener('click', function () { openDrawer(false); }); });
  $('.khs-overlay', drawer).addEventListener('click', function () { openDrawer(false); });
  document.addEventListener('keydown', function (e) {
    if (drawer.hidden) return;
    if (e.key === 'Escape') { openDrawer(false); return; }
    if (e.key === 'Tab') {
      var f = $$('button, a[href], [tabindex]:not([tabindex="-1"])', panel).filter(function (el) { return !el.disabled && !el.hidden && el.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });

  $$('[data-khs-open-cart]').forEach(function (btn) {
    btn.addEventListener('click', function () { fetchCart().then(function (cart) { drawCart(cart); openDrawer(true); }); });
  });

  // The header cart button opens this drawer instead of the theme's own
  window.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('[data-testid="cart-drawer-trigger"], a[href$="/cart"]');
    if (!trigger || drawer.contains(trigger)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    fetchCart().then(function (cart) { drawCart(cart); openDrawer(true); });
  }, true);

  /* ---------- Reservation timer ----------
     Starts when the drawer first opens or something is added; the end time
     lives in sessionStorage so it survives reloads. An active timer is not
     restarted by later adds; an expired one restarts. At 0 only the message
     changes, nothing else happens. */
  var RKEY = 'khs-reserve-end';
  var WINDOW = (Number(drawer.dataset.reserveSeconds) || 300) * 1000;
  function readEnd() { var v = 0; try { v = Number(sessionStorage.getItem(RKEY)); } catch (e) {} return v && !isNaN(v) ? v : 0; }
  function startReserve() {
    var end = readEnd();
    if (end > Date.now()) return end;
    end = Date.now() + WINDOW;
    try { sessionStorage.setItem(RKEY, String(end)); } catch (e) {}
    return end;
  }
  function clearReserve() { try { sessionStorage.removeItem(RKEY); } catch (e) {} }
  function tick() {
    var end = readEnd();
    var left = end ? Math.max(0, end - Date.now()) : WINDOW;
    $('[data-khs-reserve-time]', drawer).textContent = pad(Math.floor(left / 6e4)) + ':' + pad(Math.floor(left / 1e3) % 60);
    $('[data-khs-reserve-fill]', drawer).style.width = (left / WINDOW * 100) + '%';
    $('[data-khs-reserve-msg]', drawer).textContent = end && left <= 0 ? drawer.dataset.msgEnded : drawer.dataset.msg;
  }
  setInterval(function () { if (!drawer.hidden) tick(); }, 1000);

  fetchCart().then(function (cart) { if (cart.item_count > 0) drawCart(cart); });
}
